import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "verifyPoints" }
const _hoisted_2 = { class: "verify-img-out" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-refresh" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "verify-msg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "verify-img-panel",
        style: _normalizeStyle({'width': _ctx.setSize.imgWidth,
                                          'height': _ctx.setSize.imgHeight,
                                          'background-size' : _ctx.setSize.imgWidth + ' '+ _ctx.setSize.imgHeight,
                                          'margin-bottom': _ctx.vSpace + 'px;'})
      }, [
        _withDirectives(_createElementVNode("div", {
          class: "verify-refresh",
          style: {"z-index":"3"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
        }, _hoisted_4, 512), [
          [_vShow, _ctx.showRefresh]
        ]),
        _createElementVNode("img", {
          ref: "canvas",
          src: 'data:image/png;base64,'+_ctx.pointBackImgBase,
          style: {"width":"100%","height":"100%","display":"block"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.bindingClick? _ctx.canvasClick($event) :undefined))
        }, null, 8, _hoisted_5),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempPoints, (tempPoint, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "pointArea",
            style: _normalizeStyle({ left: `${+tempPoint.x-10}px`, top: `${+tempPoint.y - 10}px` })
          }, _toDisplayString(index + 1), 5))
        }), 128))
      ], 4)
    ]),
    _createElementVNode("div", {
      class: "verify-bar-area",
      style: _normalizeStyle({'width': _ctx.setSize.imgWidth,
               'color': _ctx.barAreaColor,
               'border-color': _ctx.barAreaBorderColor,
               'line-height':_ctx.barSize.height})
    }, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.text), 1)
    ], 4)
  ]))
}